module.exports = __webpack_public_path__ + "img/banner_desktop.590c7794.jpg";